export default "__VITE_ASSET__DO7p4oci__"